import React, { useEffect } from 'react'

//MUI
import { createTheme, ThemeProvider } from '@mui/material';

//Router dom
import { useLocation } from 'react-router-dom';

import DataContextProvider from './context/DataContext';
import RouterContextProvider from './context/RouterContext';

//Components
import AppRoute from './router/AppRoute';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1536,
    },
  },
  typography: {
    fontFamily: 'Montserrat',
  },
});

function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}

const App = () => {
  useScrollToTop();

  return (
    <ThemeProvider theme={theme}>
      <DataContextProvider>
        <RouterContextProvider>
          <AppRoute />
        </RouterContextProvider>
      </DataContextProvider>
    </ThemeProvider>
  );
};

export default App;